import React, { FC } from 'react';
import SRadioGroupSwitcher from './RadioGroupSwitcher.styles';
import TRadioGroupSwitcher from './RadioGroupSwitcher.types';

const RadioGroupSwitcher: FC<TRadioGroupSwitcher> = props => {
  return <SRadioGroupSwitcher {...props} />;
};

export default RadioGroupSwitcher;
